import { gql } from '@apollo/client';

export default gql`
  query inspectionSubject($id: ID!) {
    space {
      overInspectionsLimit
      adminRole
    }
    inspectionSubject(id: $id) {
      id
      name
      brand
      model
      serialNumber
      notes
      inspectionsTotal
      incomingInspectionsTotal
      overdueInspectionsTotal
      pendingInspectionsTotal
      complianceRatio
      place {
        id
        name
        street
        city
        zipCode
      }
    }
  }
`;
